import { useSyncExternalStore, type AnchorHTMLAttributes, type MouseEvent } from 'react';

const EVENT = 'whcc:navigate';

function subscribe(cb: () => void): () => void {
  window.addEventListener('popstate', cb);
  window.addEventListener(EVENT, cb);
  return () => {
    window.removeEventListener('popstate', cb);
    window.removeEventListener(EVENT, cb);
  };
}

function snapshot(): string {
  return window.location.pathname + window.location.search;
}

export function navigate(to: string): void {
  window.history.pushState({}, '', to);
  window.dispatchEvent(new Event(EVENT));
}

/** Localisation courante (chemin + paramètres de requête), réactive aux navigations. */
export function useLocation(): { pathname: string; search: URLSearchParams } {
  const s = useSyncExternalStore(subscribe, snapshot, snapshot);
  const i = s.indexOf('?');
  return {
    pathname: i === -1 ? s : s.slice(0, i),
    search: new URLSearchParams(i === -1 ? '' : s.slice(i)),
  };
}

export function Link({ href, onClick, ...rest }: AnchorHTMLAttributes<HTMLAnchorElement> & { href: string }) {
  const handle = (e: MouseEvent<HTMLAnchorElement>) => {
    onClick?.(e);
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    navigate(href);
  };
  return <a href={href} onClick={handle} {...rest} />;
}
